
import styled from "styled-components";

const MapAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  
  /* Typography */
  font-family: 'Our Lexend', sans-serif;
  font-size: ${({ isMobileView }) => (isMobileView ? '12px' : '14px')};
  font-weight: 500;
  line-height: ${({ isMobileView }) => (isMobileView ? '14px' : '20px')};
  letter-spacing: 0;
  text-align: ${({ isMobileView }) => (isMobileView ? 'center' : 'left')};
  vertical-align: middle;
  
  /* Text Decoration */
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 4px;
  text-decoration-thickness: 1px;
  text-decoration-skip-ink: auto;

  /* Color */
  color: var(--color-base-red-500, rgba(239, 79, 95, 1));

  &:hover {
    text-decoration: underline;
    text-decoration-style: dotted;
  }
`;

export default function MapLinkButton({ latitude, longitude, fallbackAddress, isMobileView = true }) {
  const hasWarehouseCoordinates =
    Number.isFinite(Number(latitude)) &&
    Number.isFinite(Number(longitude)) &&
    (Number(latitude) !== 0 || Number(longitude) !== 0);

  let mapUrl;
  if (hasWarehouseCoordinates) {
    mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${latitude},${longitude}`
    )}`;
  } else if (fallbackAddress) {
    mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fallbackAddress)}`;
  } else {
    return null;
  }

  return (
    <MapAnchor isMobileView={isMobileView} href={mapUrl} target="_blank" rel="noopener noreferrer">
      Open in map
    </MapAnchor>
  );
}
